<template>
  <div>
    <v-list-item>
      <v-list-item-avatar>
        <v-icon class="white--text" style="background-color: var(--v-muted-foreground-base);">{{`mdi-file-${icon}`}}</v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn icon @click="$emit('download', item, [item])">
          <v-icon color="muted-accent">mdi-download</v-icon>
        </v-btn>
      </v-list-item-action>
      <v-list-item-action>
        <SubMenu @select="(selection) => $emit(selection, item)" :options="subMenuFileItems()"/>
      </v-list-item-action>
    </v-list-item>
    <v-divider/>
  </div>
</template>

<script>
import SubMenu from '@/components/sub-menu/index.vue';
import store from '@/common/store';

export default {
  name: 'File',
  components: { SubMenu },
  props: {
    item: {
      type: Object,
      required: true,
    },
    allowDelete: {
      type: Boolean,
      required: true,
    },
    allowRename: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    icon() {
      const fileExtension = this.item.name.split('.')[1];
      let iconName = 'file';

      const types = {
        word: ['doc', 'dot', 'webk', 'docx', 'docm', 'dotx', 'dotm', 'docb'],
        excel: ['xls', 'xlt', 'xlm', 'xlsx', 'xlsm', 'xltx', 'xltm', 'xlsb', 'xla', 'xlam', 'xll', 'xlw'],
        powerpoint: ['ppt', 'pot', 'pps', 'pptx', 'pptm', 'potx', 'potm', 'ppam', 'ppsx', 'ppsm', 'sldx', 'sldm'],
        pdf: ['pdf'],
        csv: ['csv'],
        alt: ['txt'],
        image: ['png', 'jpg', 'jpeg', 'svg'],
      };

      Object.keys(types).forEach((typeName) => {
        if (types[typeName].includes(fileExtension)) {
          iconName = typeName;
        }
      });

      return iconName;
    },
  },
  methods: {
    subMenuFileItems() {
      const listActions = [];
      if (this.allowRename) { listActions.push({ title: 'Renomear', value: 'rename' }); }
      if (this.allowDelete) { listActions.push({ title: 'Excluir', value: 'delete' }); }
      listActions.push({ title: 'Informações', value: 'informations' });
      if (!store.getHasMenu() || store.getHasNotificationConfigAuthority()) {
        listActions.push({ title: 'Emitir Notificação', value: 'manualNotification' });
      }
      return listActions;
    },
  },
};
</script>
